up.compiler('.geolocator', (element: HTMLElement) => {
  const button = element.querySelector<HTMLElement>('.geolocator--button')!
  const output = element.querySelector<HTMLElement>('.geolocator--output')!

  button.addEventListener('click', () => {
    navigator.geolocation.getCurrentPosition(printLocation)
  })

  function printLocation(data: GeolocationPosition) {
    output.innerHTML = `{ lat: ${data.coords.latitude}, lon: ${data.coords.longitude} }`
  }
})
